var map = {
	"./celery.png": 4226,
	"./crustaceans.png": 4420,
	"./dairy.png": 9807,
	"./eggs.png": 494,
	"./fish.png": 8194,
	"./gluten.png": 931,
	"./lupin.png": 8176,
	"./molluscs.png": 1622,
	"./mustard.png": 1156,
	"./nuts.png": 8248,
	"./peanuts.png": 1216,
	"./sesame.png": 7866,
	"./so2_sulfites.png": 4606,
	"./soy.png": 3029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6047;